export const CODE_SNIPPETS = {
    javascript: `function greet(name) {
  console.log("Hello, " + name + "!");
}

greet("Alex");
`,
    typescript: `type Params = {
  name: string;
}

function greet(data: Params) {
  console.log("Hello, " + data.name + "!");
}

greet({ name: "Alex" });
`,
    python: `def greet(name):
    print("Hello, " + name + "!")

greet("Alex")
`,
    java: `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello World");
    }
}
`,
    c: `#include <stdio.h>

int main() {
    printf("Hello World");
    return 0;
}
`,
    cpp: `#include <iostream>

int main() {
    std::cout << "Hello World" << std::endl;
    return 0;
}
`
};
